import { Box, Button, Typography } from "@mui/material";
import React, { useRef } from "react";
import TopBar from "./TopBar";
import { FaRegFilePdf } from "react-icons/fa";
import { TbFileExport } from "react-icons/tb";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import * as XLSX from "xlsx";

const StaticTable = () => {
    const tableRef = useRef(null);

    const data = [
        { id: 1, sr_no: 1, taluka: "छत्रपती संभाजीनगर", dead_animals: 5, pm_done: 3, bills_prepared: 2, treasury_submitted: 1, registered: 4, pending: 1, fund_distributed: 2, remark: "Approved" },
        { id: 2, sr_no: 2, taluka: "सिल्लोड", dead_animals: 10, pm_done: 8, bills_prepared: 6, treasury_submitted: 5, registered: 9, pending: 2, fund_distributed: 5, remark: "Processing" },
        { id: 3, sr_no: 3, taluka: "सोयगाव", dead_animals: 7, pm_done: 5, bills_prepared: 4, treasury_submitted: 3, registered: 6, pending: 1, fund_distributed: 3, remark: "Completed" },
        { id: 4, sr_no: 4, taluka: "कन्नड", dead_animals: 15, pm_done: 10, bills_prepared: 8, treasury_submitted: 7, registered: 12, pending: 3, fund_distributed: 7, remark: "Processing" },
        { id: 5, sr_no: 5, taluka: "फुलंब्री", dead_animals: 12, pm_done: 9, bills_prepared: 7, treasury_submitted: 6, registered: 11, pending: 2, fund_distributed: 6, remark: "Pending" },
        { id: 6, sr_no: 6, taluka: "गंगापूर", dead_animals: 8, pm_done: 6, bills_prepared: 5, treasury_submitted: 4, registered: 7, pending: 1, fund_distributed: 4, remark: "Completed" },
        { id: 7, sr_no: 7, taluka: "वैजापूर", dead_animals: 14, pm_done: 11, bills_prepared: 9, treasury_submitted: 8, registered: 13, pending: 3, fund_distributed: 8, remark: "Processing" },
        { id: 8, sr_no: 8, taluka: "पैठण", dead_animals: 9, pm_done: 7, bills_prepared: 6, treasury_submitted: 5, registered: 8, pending: 1, fund_distributed: 5, remark: "Approved" },
        { id: 9, sr_no: 9, taluka: "खुलताबाद", dead_animals: 11, pm_done: 8, bills_prepared: 7, treasury_submitted: 6, registered: 10, pending: 2, fund_distributed: 6, remark: "Pending" },
    ];

    const printTable = () => {
        const buttons = document.querySelectorAll(".no-print");

        // Hide buttons
        buttons.forEach((btn) => btn.classList.add("hidden-export"));

        const input = tableRef.current;
        html2canvas(input, { scale: 2 }).then((canvas) => {
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF("l", "mm", "a4");
            const imgWidth = 280;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            pdf.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight);
            pdf.save("table.pdf");

            // Show buttons again
            buttons.forEach((btn) => btn.classList.remove("hidden-export"));
        });
    };

    const exportToExcel = () => {
        const buttons = document.querySelectorAll(".no-print");

        // Hide buttons
        buttons.forEach((btn) => btn.classList.add("hidden-export"));

        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        XLSX.writeFile(workbook, "table.xlsx");

        // Show buttons again
        setTimeout(() => {
            buttons.forEach((btn) => btn.classList.remove("hidden-export"));
        }, 100);
    };


    return (
        <Box className="ff_baloo" sx={{ width: "90%", marginLeft: "6.5%", marginTop: "6.5%" }}>
            <TopBar />
            <div ref={tableRef}>
                <h2 className="text-3xl font-bold m-4 text-center">नैसर्गिक आपत्ती मुळे मयत जनावरांचा तपशिल</h2>
                <div className="overflow-x-auto">
                    <Box sx={{ display: "flex", justifyContent: "end", mb: 2, gap: 2, marginLeft: "6.5%" }}>
                        <Button variant="contained" color="primary" onClick={printTable} sx={{ padding: "6px 14px" }} className="no-print">
                            Download PDF <FaRegFilePdf className="ms-2" fontSize={"18px"} />
                        </Button>
                        <Button variant="contained" color="success" onClick={exportToExcel} sx={{ padding: "6px 14px" }} className="no-print">
                            Download Excel <TbFileExport className="ms-1" fontSize={"19px"} />
                        </Button>
                    </Box>
                    <table className="min-w-full bg-white border border-gray-300">
                        <thead className="bg-gray-200">
                            <tr>
                                <th className="py-1 px-6 border border-gray-300 text-center">Sr.No</th>
                                <th className="py-1 px-6 border border-gray-300 text-center">तालुका</th>
                                <th className="py-1 px-6 border border-gray-300 text-center">मयत झालेल्या जनावरांची संख्या</th>
                                <th className="py-1 px-6 border border-gray-300 text-center">PM झालेल्या जनावरांची संख्या</th>
                                <th className="py-1 px-6 border border-gray-300 text-center">बिल तयार झालेली संख्या</th>
                                <th className="py-1 px-6 border border-gray-300 text-center">कोषागारामध्ये दाखल बिलाची संख्या</th>
                                <th className="py-1 px-6 border border-gray-300 text-center">रजिस्ट्रेशन झालेली संख्या</th>
                                <th className="py-1 px-6 border border-gray-300 text-center">प्रलंबित</th>
                                <th className="py-1 px-6 border border-gray-300 text-center">पशुधन मालकास निधी वितरण संख्या</th>
                                <th className="py-1 px-6 border border-gray-300 text-center">शेरा</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((item) => (
                                <tr key={item.id}>
                                    <td className="py-1 px-6 border border-gray-300">{item.sr_no}</td>
                                    <td className="py-1 px-6 border border-gray-300">{item.taluka}</td>
                                    <td className="py-1 px-6 border border-gray-300">{item.dead_animals}</td>
                                    <td className="py-1 px-6 border border-gray-300">{item.pm_done}</td>
                                    <td className="py-1 px-6 border border-gray-300">{item.bills_prepared}</td>
                                    <td className="py-1 px-6 border border-gray-300">{item.treasury_submitted}</td>
                                    <td className="py-1 px-6 border border-gray-300">{item.registered}</td>
                                    <td className="py-1 px-6 border border-gray-300">{item.pending}</td>
                                    <td className="py-1 px-6 border border-gray-300">{item.fund_distributed}</td>
                                    <td className="py-1 px-6 border border-gray-300">{item.remark}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <Box display={"flex"} justifyContent={"center"}>
                <Box

                    sx={{
                        border: "2px dashed #4caf50",
                        borderRadius: "8px",
                        backgroundColor: "#00bf0a05",
                        padding: "40px",
                        textAlign: "center",
                        width: "30%",
                        mt: 3,
                        mb: 3,
                        transition: "border 0.3s ease",
                        "&:hover": {
                            borderColor: "#388e3c",
                        },
                    }}
                >

                    <Typography variant="h6" sx={{ mb: 1, fontWeight: "bold" }}>
                        Upload Excel File
                    </Typography>
                    <Typography variant="body2" sx={{ color: "#777" }}>
                        Drag and drop an Excel file here, or click to select a file
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default StaticTable;